export default [
    ["bc-red", "Rojo"],
    ["bc-pink", "Rosa"],
    ["bc-green", "Verde"],
    ["bc-purple", "Violeta"],
    ["bc-orange", "Naranja"],
    ["bc-turquoise", "Turquesa"],
    ["bc-blue", "Azul"]
]